<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <div class="card mb-3">
        <div class="card-header">
          <fa-icon [icon]="['fas', 'marker']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>{{ 'label.my-messages' | translate }}
        </div>
        <div class="card-body">
          <ng-container *ngIf="minaRequests.length">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
                  </span>
                </div>
                <input [(ngModel)]="filterText" type="text" name="filter" class="form-control rounded-right" placeholder="{{ 'label.filter' | translate}}" (ngModelChange)="applyFilter()">
              </div>
            </div>
            <div *ngIf="minaRequests.length" class="panel panel-default">
              <div class="panel-heading">
                <p class="h5">{{ 'label.info-requests' | translate }}</p>
              </div>
              <div class="panel-body">
                <div class="table-responsive" *ngIf="minaRequests.length">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" [class.order-active]="order==='case'" (click)="setOrder('case')">
                          <div class="d-flex justify-content-between">
                            {{ 'label.case' | translate }}
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="order==='date'" (click)="setOrder('date')">
                          <div class="d-flex justify-content-between">
                            {{ 'label.sent' | translate }}
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="order==='requestFirm'" (click)="setOrder('requestFirm')">
                          <div class="d-flex justify-content-between">
                            {{ 'label.sender' | translate }}
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="order==='about'" (click)="setOrder('about')">
                          <div class="d-flex justify-content-between">
                            {{ 'label.subject' | translate }}
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="order==='status.namn'" (click)="setOrder('status.namn')">
                          <div class="d-flex justify-content-between">
                            {{ 'label.status' | translate }}
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr [id]="t.id" class="link" *ngFor="let t of minaRequests | orderBy: order:reverse:'case-insensitive' | filterBy: userFilter" [routerLink]="['/mina-meddelanden', t.id]">
                        <td data-name="Ärende">{{ t.case }}</td>
                        <td data-name="Skickad">{{ t.date | localizeddate:'shortDate' }} {{ t.date | localizeddate:'shortTime' }}</td>
                        <td data-name="Avsändare">{{ t.requestFirm }}</td>
                        <td data-name="Ämne">{{ t.about }}</td>
                        <td data-name="Status" *ngIf="t.answered">{{'label.request-answered' | translate }}</td>
                        <td data-name="Status" *ngIf="!t.answered"><b>{{'label.request-waiting-response' | translate }}</b></td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th data-name="Antal" colspan="5">{{ (minaRequests | filterBy: userFilter).length | localizednumber }} {{ 'label.st' | translate }}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <p class="text-muted" *ngIf="!(minaRequests | filterBy: userFilter).length">{{ label.no-hits | translate }}</p>
              </div>
            </div>
          </ng-container>
          <p class="text-muted" *ngIf="!minaRequests.length">{{ label.no-messages | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>